<ng-container *transloco="let t; prefix: 'loan-wizard'">
  <div class="flex-1 flex flex-col">
    <div class="container mb-[20px]" *ngIf="!showResultPage">
      <progress-stepper [StepNo]="this.stepKeys.indexOf(this.activeStep) + 1" [Steps]="stepValues"></progress-stepper>
    </div>
    <ng-container [formGroup]="loanForm">
      <div class="container flex flex-row flex-1 gap-8">
        <div class="flex flex-col gap-8 min-h-[570px] flex-1"> @if (showChoosePropertyUi) { <ng-container
            *ngIf="activeStep==='property'">
            <div class="max-w-[800px] w-full mx-auto">
              <h4 class="text-center text-black font-semibold text-3xl mb-4"> {{ t("property-step.title") }} </h4>
              <p class="text-center text-lg text-gray-800"> {{ t("property-step.subtitle") }} </p>
            </div>
            <div class="max-w-[800px] w-full mx-auto">
              <div class="">
                <div class="p-1 border-full border border-gray-500 flex flex-row rounded-full mb-8">
                  <button class="tab-pill flex-1 justify-center" type="button"
                    [ngClass]="{ active: selectedPropertyFromCategory === propertyFromCategories.favorite }"
                    (click)="onPropertyFromCategory(propertyFromCategories.favorite)">
                    <i class="icon-heart"></i>{{ t("property-step.tabs.favorite") }} </button>
                  <button class="tab-pill flex-1 justify-center" type="button"
                    [ngClass]="{ active: selectedPropertyFromCategory === propertyFromCategories.byCode }"
                    (click)="onPropertyFromCategory(propertyFromCategories.byCode)">
                    <i class="icon-edit"></i>{{ t("property-step.tabs.code") }} </button>
                </div>
              </div>
              <div class="mt-8"> @if (selectedPropertyFromCategory === propertyFromCategories.favorite) {
                <app-filter-property-dropdown class="flex flex-1 w-full max-w-[800px]"
                  [dropdownItems]="propertyFavouritesFiltered" [labelName]="t('choose-property')"
                  [maxHeightOnDropdownOpen]="'52'"
                  [inputPlaceholder]="favoritePropertySelected?.title ?? t('placeholder.select-property')"
                  (propertySelected)="handlePropertySelection($event)" /> } @else if (selectedPropertyFromCategory ===
                propertyFromCategories.byCode) { <fieldset class="flex flex-col gap-2 group/input max-w-[384px] w-full">
                  <label
                    class="font-semibold flex items-center gap-2 text-black group-disabled:text-gray-300">{{t('property-code')}}<span
                      class="text-red">*</span>
                    <i class="icon-info-circle text-gray-700 text-xl" customTooltip
                      [tooltipTemplate]="propetyCodeTooltip"
                      tooltipImg="../../../../assets/img/property-code-guide.png"></i></label>
                  <ng-template #propetyCodeTooltip> {{t('propertyCodeTooltip')}} </ng-template>
                  <input [formControl]="propertyByCodeInput"
                    class="bg-white text-gray-500 rounded-full border border-gray-200 py-3 px-4 group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none">
                </fieldset> }
              </div>
            </div>
          </ng-container> } <ng-container *ngIf="activeStep=='loan'" [formGroupName]="'loan'">
            <div class="max-w-[800px] w-full mx-auto">
              <h4 class="text-center text-black font-semibold text-3xl mb-4"> {{ t('reviewLoanCalculation') }} </h4>
              <p class="text-center text-lg text-gray-800"> {{ t('loan-step.subtitle') }} </p>
            </div>
            <div class="flex lg:flex-row flex-col gap-20 lg:items-start items-center">
              <app-loan-calulator [calcValues]="calcValue" class="flex-1"></app-loan-calulator>
              <div class="max-w-[360px] w-full">
                <app-doughnut-chart [showEstimatedFees]="false"></app-doughnut-chart>
                <div class="mt-6 text-gray-700 font-semibold flex flex-row gap-2 text-xs justify-center"> {{
                  t("fulfilledby") }} <img
                    src="{{'assets/svgs/nbg-logo-black' + (activeLang === 'en' ? '-en': '') +'.svg'}}" alt="NBG Logo" />
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="activeStep=='details'" [formGroupName]="'details'">
            <div class="max-w-[800px] w-full mx-auto">
              <div class="w-full mx-auto mb-12">
                <h4 class="text-center text-black font-semibold text-3xl mb-4"> {{ t('yourDetails') }} </h4>
                <p class="text-center text-lg text-gray-800"> {{ t('details-step.subtitle') }} </p>
              </div>
              <div class="flex flex-col gap-10">
                <fieldset class="flex flex-col gap-2 group/input">
                  <label class="font-semibold flex items-center gap-2 text-black group-disabled:text-gray-300">
                    <div>{{ t('details-step.tin') }}</div><span class="text-error">*</span>
                  </label>
                  <div
                    class="border border-gray-300 rounded-full bg-white overflow-hidden max-w-[384px] flex flex-row gap-2 items-center py-3 px-4 group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none">
                    <input [formControlName]="'tinNumber'" class="text-black w-full bg-transparent flex-1 outline-none"
                      mask="0*" type="text">
                  </div>
                  <span *ngIf="hasError('details.tinNumber')" class="text-error">{{ 'shared.error.requiredField' |
                    transloco }}</span>
                </fieldset>
                <div class="flex flex-col gap-4">
                  <div class="font-semibold flex items-center gap-2 text-black group-disabled:text-gray-300"> {{
                    t('details-step.whatsYourNationality') }}<span class="text-error">*</span>
                  </div>
                  <div class="flex flex-row flex-wrap gap-4">
                    <label class="visual-checkbox visual-col" for="nationality-greek">
                      <input (change)="onNationalityChange(nationalityType.greek)" [formControlName]="'nationality'"
                        [value]="nationalityType.greek" class="opacity-0 absolute h-0 w-0" id="nationality-greek"
                        name="nationality" type="radio">
                      <span class="">{{ t('details-step.nationalityType.greek') }}</span>
                    </label>
                    <label class="visual-checkbox visual-col" for="nationality-in-eu">
                      <input (change)="onNationalityChange(nationalityType.inEU)" [formControlName]="'nationality'"
                        [value]="nationalityType.inEU" class="opacity-0 absolute h-0 w-0" id="nationality-in-eu"
                        name="nationality" type="radio">
                      <span class="">{{ t('details-step.nationalityType.inEU') }}</span>
                    </label>
                    <label class="visual-checkbox visual-col" for="nationality-out-of-eu">
                      <input (change)="onNationalityChange(nationalityType.outsideEU)" [formControlName]="'nationality'"
                        [value]="nationalityType.outsideEU" class="opacity-0 absolute h-0 w-0"
                        id="nationality-out-of-eu" name="nationality" type="radio">
                      <span class="">{{ t('details-step.nationalityType.outsideEU') }}</span>
                    </label>
                  </div>
                  <span *ngIf="hasError('details.nationality')" class="text-error">{{ 'shared.error.requiredField' |
                    transloco }}</span>
                </div>
                <div class="flex flex-col gap-4">
                  <div class="text-black flex flex-row items-center font-semibold gap-2">
                    <div>{{ t('professionalStatus') }}</div><span class="text-error">*</span>
                  </div>
                  <div class="flex flex-row flex-wrap gap-4">
                    <label class="visual-checkbox visual-col" for="professionalStatus-radio-1">
                      <input [formControlName]="'professionalStatus'" class="opacity-0 absolute h-0 w-0"
                        id="professionalStatus-radio-1" name="professionalStatus" type="radio" value="employed">
                      <span class="">{{ t('employed') }}</span>
                    </label>
                    <label class="visual-checkbox visual-col" for="professionalStatus-radio-2">
                      <input [formControlName]="'professionalStatus'" class="opacity-0 absolute h-0 w-0"
                        id="professionalStatus-radio-2" name="professionalStatus" type="radio" value="selfEmployed">
                      <span class="">{{ t('selfEmployed') }}</span>
                    </label>
                    <label class="visual-checkbox visual-col" for="professionalStatus-radio-3">
                      <input [formControlName]="'professionalStatus'" class="opacity-0 absolute h-0 w-0"
                        id="professionalStatus-radio-3" name="professionalStatus" type="radio" value="retired">
                      <span class="">{{ t('retired') }}</span>
                    </label>
                  </div>
                  <span *ngIf="hasError('details.professionalStatus')" class="text-error">{{
                    'shared.error.requiredField' | transloco }}</span>
                </div>
                <div class="divider-line1"></div>
                <fieldset class="flex flex-col gap-2 group/input max-w-[384px]">
                  <label class="font-semibold flex items-center gap-2 text-black group-disabled:text-gray-300">
                    <div>{{ t("details-step.birth-year") }}</div><span class="text-error">*</span>
                  </label>
                  <div
                    class="border border-gray-300 rounded-full bg-white overflow-hidden flex flex-row gap-2 items-center py-3 px-4 group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none">
                    <span>{{t('year')}}</span>
                    <input [formControlName]="'yearBorn'" class="text-black w-full bg-transparent flex-1 outline-none"
                      mask="9999" type="text">
                    <span *ngIf="hasError('details.yearBorn')" class="text-error">{{ 'shared.error.requiredField' |
                      transloco }}</span>
                  </div>
                  <div class="text-gray-900 text-md"> {{ t('details-step.loan-paid-of') }} </div>
                </fieldset>
                <div class="flex flex-col gap-4">
                  <div class="text-black flex flex-row items-center font-semibold gap-2">
                    <div>{{ t('marriageStatus') }}</div><span class="text-error">*</span>
                  </div>
                  <div class="flex flex-row flex-wrap gap-4">
                    <label class="visual-checkbox visual-col" for="marriageStatus-radio-1">
                      <input [formControlName]="'marriageStatus'" class="opacity-0 absolute h-0 w-0"
                        id="marriageStatus-radio-1" type="radio" value="single">
                      <span class="">{{ t('single') }}</span>
                    </label>
                    <label class="visual-checkbox visual-col" for="marriageStatus-radio-2">
                      <input [formControlName]="'marriageStatus'" class="opacity-0 absolute h-0 w-0"
                        id="marriageStatus-radio-2" type="radio" value="married">
                      <span class="">{{ t('married') }}</span>
                    </label>
                    <label class="visual-checkbox visual-col" for="marriageStatus-radio-3">
                      <input [formControlName]="'marriageStatus'" class="opacity-0 absolute h-0 w-0"
                        id="marriageStatus-radio-3" type="radio" value="cohabitation">
                      <span class="">{{ t('cohabitation') }}</span>
                    </label>
                  </div>
                  <span *ngIf="hasError('details.marriageStatus')" class="text-error">{{ 'shared.error.requiredField' |
                    transloco }}</span>
                </div>
                <div class="flex flex-col gap-4">
                  <div class="text-black flex flex-row items-center font-semibold gap-2">
                    <div>{{ t('howManyChildren') }}</div><span class="text-error">*</span>
                  </div>
                  <div class="flex flex-row flex-wrap gap-4">
                    <label class="visual-checkbox visual-col" for="children-radio-1">
                      <input [formControlName]="'children'" [value]="'0'" class="opacity-0 absolute h-0 w-0"
                        id="children-radio-1" type="radio">
                      <span class="">0</span>
                    </label>
                    <label class="visual-checkbox visual-col" for="children-radio-2">
                      <input [formControlName]="'children'" [value]="'1'" class="opacity-0 absolute h-0 w-0"
                        id="children-radio-2" type="radio">
                      <span class="">1</span>
                    </label>
                    <label class="visual-checkbox visual-col" for="children-radio-3">
                      <input [formControlName]="'children'" [value]="'2'" class="opacity-0 absolute h-0 w-0"
                        id="children-radio-3" type="radio">
                      <span class="">2</span>
                    </label>
                    <label class="visual-checkbox visual-col" for="children-radio-4">
                      <input [formControlName]="'children'" [value]="'3'" class="opacity-0 absolute h-0 w-0"
                        id="children-radio-4" type="radio">
                      <span class="">3</span>
                    </label>
                    <label class="visual-checkbox visual-col" for="children-radio-5">
                      <input [formControlName]="'children'" [value]="'4'" class="opacity-0 absolute h-0 w-0"
                        id="children-radio-5" type="radio">
                      <span class="">4</span>
                    </label>
                    <label class="visual-checkbox visual-col" for="children-radio-6">
                      <input [formControlName]="'children'" [value]="'5+'" class="opacity-0 absolute h-0 w-0"
                        id="children-radio-6" type="radio">
                      <span class="">5+</span>
                    </label>
                  </div>
                  <span *ngIf="hasError('details.children')" class="text-error">{{ 'shared.error.requiredField' |
                    transloco }}</span>
                </div>
                <span class="text-xs text-900">{{ t("details-step.disclaimers") }}</span>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="activeStep=='financialDetails'" [formGroupName]="'financialDetails'">
            <div class="max-w-[800px] w-full mx-auto">
              <div class="w-full mx-auto mb-12">
                <h4 class="text-center text-black font-semibold text-3xl mb-4"> {{ t("finance-step.title") }} </h4>
                <p class="text-center text-lg text-gray-800"> {{ t("finance-step.subtitle") }} </p>
              </div>
              <div class="flex lg:flex-row flex-col gap-8">
                <fieldset class="flex flex-1 flex-col gap-2 group/input">
                  <label
                    class="font-semibold flex items-center justify-between gap-2 text-black group-disabled:text-gray-300">
                    <div class="flex flex-row">
                      <div>{{ t("finance-step.gross-salary") }}</div>
                      <span class="text-error">*</span>
                    </div>
                    <i class="icon-info-circle" customTooltip [tooltipTemplate]="grossSalaryTooltip"
                      tooltipImg="../../../../assets/img/property-code-guide.png"></i>
                  </label>
                  <ng-template #grossSalaryTooltip> {{t('finance-step.gross-salary-tooltip')}} </ng-template>
                  <div
                    class="border border-gray-300 rounded-full bg-white overflow-hidden flex flex-row gap-2 items-center py-3 px-4 group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none">
                    <div class="text-gray-900 font-semibold">€</div>
                    <input [formControlName]="'grossSalaryPerYear'" [thousandSeparator]="'.'"
                      class="text-black w-full bg-transparent flex-1 outline-none" mask="separator.2" type="text">
                  </div>
                  <span *ngIf="hasError('financialDetails.grossSalaryPerYear')" class="text-error">{{
                    'shared.error.requiredField' | transloco }}</span>
                </fieldset>
                <fieldset class="flex flex-1 flex-col gap-2 group/input">
                  <label
                    class="font-semibold flex items-center justify-between gap-4 text-black group-disabled:text-gray-300">
                    <div>{{ t("finance-step.yearly-dept") }}<span class="text-error">*</span></div>
                    <i class="icon-info-circle" customTooltip [tooltipTemplate]="myTooltipTemplate"></i>
                  </label>
                  <ng-template #myTooltipTemplate> {{t('finance-step.yearly-dept-tooltip')}} </ng-template>
                  <div
                    class="border border-gray-300 rounded-full bg-white overflow-hidden flex flex-row gap-2 items-center py-3 px-4 group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none">
                    <div class="text-gray-900 font-semibold">€</div>
                    <input [formControlName]="'householdDebt'" [thousandSeparator]="'.'"
                      class="text-black w-full bg-transparent flex-1 outline-none" mask="separator.2" type="text">
                  </div>
                  <div class="text-sm text-gray-900"> {{ t("finance-step.dept-disclaimer") }} </div>
                  <span *ngIf="hasError('financialDetails.householdDebt')" class="text-error">{{
                    'shared.error.requiredField' | transloco }}</span>
                </fieldset>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="activeStep=='review'" [formGroupName]="'review'">
            <div class="w-full mx-auto mb-12 mt-12">
              <h4 class="text-black font-semibold mb-4"
                [ngClass]="{ 'text-[2.5rem] text-left' : showResultPage, 'text-center text-3xl' : !showResultPage }">
                {{!showResultPage ? t('reviewYourDetails') : t('resultTitle') }} </h4>
              <p class="rfs:text-[26px] text-gray-900"
                [ngClass]="{ 'text-left' : showResultPage, 'text-center' : !showResultPage }"> {{!showResultPage ?
                t('review-step.subtitle') : t('resultSubtitle') }} </p>
            </div>
            <div class="flex xl:flex-row flex-col xl:items-start items-center gap-12">
              <div class="flex-1">
                <div class="mb-8" *ngIf="showResultPage">
                  <div class="px-6 pt-6 pb-8 bg-gray-100 flex flex-col gap-6">
                    <div class="flex flex-row justify-between">
                      <div>
                        <div class="text-black mb-1">{{ t("review-step.your-application-number") }}</div>
                        <div class="text-black font-semibold text-[2rem]">{{ caseId }}</div>
                      </div>
                      <div class="w-[36px] h-[36px] rounded-full bg-primary-500 flex items-center justify-center">
                        <i class="icon-check text-black text-lg"></i>
                      </div>
                    </div>
                    <div class="divider-line1"></div>
                    <div>
                      <p class="text-gray-900">{{ t("review-step.check-your-application.part-1") }} <a
                          class="text-primary-600 underline cursor-pointer"
                          [localizedRouterLink]="['/my-profile/requests']">{{
                          t("review-step.check-your-application.link")
                          }}</a>{{ t("review-step.check-your-application.part-2") }} </p>
                    </div>
                  </div>
                </div>
                <div class="mb-8">
                  <app-property-card-item [isClickable]="false" [withBorder]="false" [showFavorite]="false"
                    [propertySummary]="propertyCardSummaryData"></app-property-card-item>
                </div>
                <div class="mb-8">
                  <div class="text-gray-900 font-semibold mb-4">{{ t('yourLoanAmount') }}</div>
                  <div class="bg-white p-4 rounded-[4px]">
                    <div class="grid grid-cols-1 md:grid-cols-2 rfs:gap-8 pb-4">
                      <div class="flex flex-col gap-[14px]">
                        <div class="flex justify-between divider-line1 border-b-gray-300 pb-[10px]">
                          <p class="flex-1">{{ t('loanType') }}</p>
                          <p class="flex-1 text-black font-semibold">
                            <ng-container [ngSwitch]="loanForm.get('loan.categoryId')?.value">
                              <ng-container *ngSwitchCase="propertyMortgageCategoryId">{{ t('answerLoanTypeMortgage') }}
                              </ng-container>
                              <ng-container *ngSwitchCase="propertyRenovationCategoryId">{{
                                t('answerLoanTypeRenovation') }} </ng-container>
                            </ng-container>
                          </p>
                        </div>
                        <div class="flex justify-between divider-line1 border-b-gray-300 pb-[10px]">
                          <p class="flex-1">{{ t('loanAmount') }}</p>
                          <p class="flex-1 text-black font-semibold">€ {{ loanForm.get('loan.amount')?.value | number }}
                          </p>
                        </div>
                        <div class="flex justify-between divider-line1 border-b-gray-300 pb-[10px]">
                          <p class="flex-1">{{ t('fixedInterestDuration') }}</p>
                          <p class="flex-1 text-black font-semibold"> {{
                            loanForm.get('loan.fixedInterestDuration')?.value }} {{ t('years') }} </p>
                        </div>
                      </div>
                      <div class="flex flex-col gap-[14px]">
                        <div class="flex justify-between divider-line1 border-b-gray-300 pb-[10px]">
                          <p class="flex-1">{{ t('propertyValue') }}</p>
                          <p class="flex-1 text-black font-semibold">€ {{ loanForm.get('loan.realEstateValue')?.value |
                            number }}</p>
                        </div>
                        <div class="flex justify-between divider-line1 border-b-gray-300 pb-[10px]">
                          <p class="flex-1">{{ t('loanDuration') }}</p>
                          <p class="flex-1 text-black font-semibold"> {{ loanForm.get('loan.duration')?.value }} {{
                            t('years') }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-8">
                  <div class="text-gray-900 font-semibold mb-4">{{ t('yourDetails') }}</div>
                  <div class="bg-white p-4 rounded-[4px]">
                    <div class="grid grid-cols-1 md:grid-cols-2 rfs:gap-8">
                      <div class="flex flex-col gap-[14px]">
                        <div class="flex justify-between divider-line1 border-b-gray-300 pb-[10px]">
                          <p class="flex-1">{{ t('yearBornTitle') }}</p>
                          <p class="flex-1 text-black font-semibold">{{ loanForm.get('details.yearBorn')?.value }}</p>
                        </div>
                        <div class="flex justify-between divider-line1 border-b-gray-300 pb-[10px]">
                          <p class="flex-1"> {{ t('marriageStatusTitle') }} </p>
                          <p class="flex-1 text-black font-semibold">
                            <ng-container [ngSwitch]="loanForm.get('details.marriageStatus')?.value">
                              <ng-container *ngSwitchCase="'single'">{{ t('answerSingle') }} </ng-container>
                              <ng-container *ngSwitchCase="'married'">{{ t('answerMarried') }} </ng-container>
                              <ng-container *ngSwitchCase="'cohabitation'">{{ t('answerCohabitation') }} </ng-container>
                            </ng-container>
                          </p>
                        </div>
                        <div class="flex justify-between divider-line1 border-b-gray-300 pb-[10px]">
                          <p class="flex-1">{{ t('nationality') }}</p>
                          <p class="flex-1 text-black font-semibold">{{ 'loan-wizard.details-step.nationalityType.' +
                            loanForm.get('details.nationality')?.value | transloco }}
                          </p>
                        </div>
                      </div>
                      <div class="flex flex-col gap-[14px]">
                        <div class="flex justify-between divider-line1 border-b-gray-300 pb-[10px]">
                          <p class="flex-1">{{ t('tinTitle') }}</p>
                          <p class="flex-1 text-black font-semibold">{{ loanForm.get('details.tinNumber')?.value }}</p>
                        </div>
                        <div class="flex justify-between divider-line1 border-b-gray-300 pb-[10px]">
                          <p class="flex-1">{{ t('children') }}</p>
                          <p class="flex-1 text-black font-semibold">{{ loanForm.get('details.children')?.value }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-8">
                  <div class="text-gray-900 font-semibold mb-4">{{ t('yourFinance') }}</div>
                  <div class="bg-white p-4 rounded-[4px]">
                    <div class="grid grid-cols-1 md:grid-cols-2 rfs:gap-8">
                      <div class="flex flex-col gap-[14px]">
                        <div class="flex justify-between divider-line1 border-b-gray-300 pb-[10px]">
                          <p class="flex-1">{{ t("review-step.gross-income") }}</p>
                          <p class="flex-1 text-black font-semibold">{{
                            loanForm.get('financialDetails.grossSalaryPerYear')?.value | number }} €</p>
                        </div>
                      </div>
                      <div class="flex flex-col gap-[14px]">
                        <div class="flex justify-between h-full divider-line1 border-b-gray-300 pb-[10px]">
                          <p class="flex-1"> {{ t("review-step.yearly-dept") }} </p>
                          <p class="flex-1 text-black font-semibold"> {{
                            loanForm.get('financialDetails.householdDebt')?.value | number}}€ </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="!showResultPage" class="p-4 border rounded-[4px] border-gray-400 mb-4">
                  <label class="checkbox-selector" for="checkbox-selector-test-check-1">
                    <input [formControlName]="'consentEditApplication'" class="hidden"
                      id="checkbox-selector-test-check-1" type="checkbox">
                    <div class="checkbox-selector-content">
                      <span class="checkbox-selector-text ml-4 font-normal"> {{ t('consentLoan') }} </span>
                    </div>
                  </label>
                </div>
                <span *ngIf="hasError('review.consentEditApplication')" class="text-error">{{ t('consentLoanInfoError')
                  }}</span>
                <div *ngIf="!showResultPage" class="p-4 border rounded-[4px] border-gray-400">
                  <label class="checkbox-selector" for="checkbox-selector-test-check-2">
                    <input [formControlName]="'consentPersonalDetails'" class="hidden"
                      id="checkbox-selector-test-check-2" type="checkbox">
                    <div class="checkbox-selector-content">
                      <span class="checkbox-selector-text ml-4 font-normal"> {{
                        t("review-step.consent-personal-details") }} </span>
                    </div>
                  </label>
                </div>
                <span *ngIf="hasError('review.consentPersonalDetails')" class="text-error">{{ t('consentLoanInfoError')
                  }}</span>
              </div>
              <div class="max-w-[360px] w-full">
                <app-doughnut-chart [showEstimatedFees]="false"></app-doughnut-chart>
                <div class="mt-6 text-gray-700 font-semibold flex flex-row gap-2 text-xs justify-center">
                  {{ t("fulfilledby") }} <img
                    src="{{'assets/svgs/nbg-logo-black' + (activeLang === 'en' ? '-en': '') +'.svg'}}" alt="NBG Logo" />
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
    <app-navigation-buttons (ExitButtonClicked)="openModalComponent()" (NextButtonClicked)="onNextClick()"
      [NextButtonEnabled]="loanForm.get(activeStep)?.valid ?? false" *ngIf="activeStep=='property'"
      [HidePrevious]="true" [HideSkip]="true"></app-navigation-buttons>
    <app-navigation-buttons (ExitButtonClicked)="openModalComponent()" (NextButtonClicked)="onNextClick()"
      [NextButtonEnabled]="loanForm.get(activeStep)?.valid ?? false" (PreviousButtonClicked)="onPrevClick()"
      *ngIf="activeStep=='loan'" [HidePrevious]="getStepIndex('loan') === 0" [HideSkip]="true"></app-navigation-buttons>
    <app-navigation-buttons (ExitButtonClicked)="openModalComponent()" (NextButtonClicked)="onNextClick()"
      [NextButtonEnabled]="loanForm.get(activeStep)?.valid ?? false" (PreviousButtonClicked)="onPrevClick()"
      *ngIf="activeStep=='details'" [HideSkip]="true"></app-navigation-buttons>
    <app-navigation-buttons (ExitButtonClicked)="openModalComponent()" (NextButtonClicked)="onNextClick()"
      [NextButtonEnabled]="loanForm.get(activeStep)?.valid ?? false" (PreviousButtonClicked)="onPrevClick()"
      *ngIf="activeStep=='financialDetails'" [HideSkip]="true"></app-navigation-buttons>
    <app-navigation-buttons (ExitButtonClicked)="openModalComponent()" (NextButtonClicked)="onNextClick()"
      [NextButtonEnabled]="loanForm.get(activeStep)?.valid ?? false" (PreviousButtonClicked)="onPrevClick()"
      *ngIf="activeStep=='branch'" [HideSkip]="true"></app-navigation-buttons>
    <app-navigation-buttons (ExitButtonClicked)="openModalComponent()" (NextButtonClicked)="onNextClick()"
      [NextButtonEnabled]="loanForm.get(activeStep)?.valid ?? false" (PreviousButtonClicked)="onPrevClick()"
      *ngIf="activeStep=='review' && !this.showResultPage" [CustomNextTitle]="t('submitLoanAppButton')"
      [HideNext]="false" [HideSkip]="true"></app-navigation-buttons>
  </div>
</ng-container>
<!-- <div
  class="mt-6 text-gray-700 font-semibold flex flex-row gap-2 text-xs"> {{ "financing.calculator-section.fulfilledby" | transloco }} <img
    src="assets/static/NBG-logo.png" alt="NBG Logo" />
</div> -->